import $ from 'jquery';
import Bloodhound from 'corejs-typeahead';

const website_locale_path = `/${window.location.pathname.split('/')[1]}`;

var initBloodhound = function () {
  console.log('initBloodhound');
  window.ort_site = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('result'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: website_locale_path + '/search?q=%QUERY',
      wildcard: '%QUERY',
      filter: function (list) {
        return list.result;
      },
    },
  });
};

var initSearch = function () {
  console.log('initSearch');

  // Initialize Bloodhound or your source
  initBloodhound();

  const searchInput = $('.search-box .search-box-input').not('.fullsite-search-box .search-box-input');

  searchInput.typeahead(
    {
      minLength: 3,
      highlight: false,
    },
    {
      name: 'ort_site',
      display: 'value',
      source: window.ort_site, // your Bloodhound source
      templates: {
        // Header: button above the list
        header: function (data) {
          var q = encodeURIComponent(data.query);
          var txt = website_locale_path === '/en' ? 'Show all results' : 'Alle Ergebnisse anzeigen';
          var searchPage = website_locale_path === '/en' ? 'search' : 'suche';
          var s = website_locale_path + '/service/' + searchPage + '#q=' + decodeURIComponent(q);

          return `<div class="tt-header">
                    <button class="btn btn-arrow p-0 mb-2" onclick="window.location='${s}'">
                        <span>${txt}</span>
                    </button>
                  </div>`;
        },

        // Suggestion: each item is an <li>
        suggestion: function (data) {
          return `<li class="tt-suggestion">${data.html}</li>`;
        },

        // No results
        notFound: function (data) {
          var escapedQuery = $('<span>').text(data.query).html();
          var msg = website_locale_path === '/en'
            ? `No matches for "${escapedQuery}"`
            : `Keine Ergebnisse für "${escapedQuery}" gefunden`;
          return `<li class="tt-suggestion empty-message">${msg}</li>`;
        },

        // Pending / loading
        pending: `<li class="tt-suggestion loading"><span style="width:50px;display:inline-block"><svg viewBox="0 0 100 100" role="img"><circle cx="50" cy="50" fill="none" stroke="#cccccc" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(303.32 50 50)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="3.03s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg></span></li>`,
      },
    }
  );

  // Wrap suggestions in a <ul> dynamically
  searchInput.bind('typeahead:render', function () {
    $('.tt-dataset').each(function () {
      var $items = $(this).children('.tt-suggestion');
      if ($items.length > 0 && !$items.parent().is('ul')) {
        $items.wrapAll('<ul class="tt-list"></ul>');
      }
    });
  });

  // Enter key triggers search page
  searchInput.on('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = encodeURIComponent($(e.target).val());
      var s = website_locale_path + '/service/' + (website_locale_path === '/en' ? 'search' : 'suche') + '#q=' + q;
      window.location = s;
      $('#navi-search-toggle').prop('checked', false);
    }
  });

  // Search button click triggers search page
  $('.search-box .search-box-button-with-redirect').on('click', function () {
    var q = encodeURIComponent(searchInput.val());
    if (q.trim().length > 0) {
      var s = website_locale_path + '/service/' + (website_locale_path === '/en' ? 'search' : 'suche') + '#q=' + q;
      window.location = s;
      $('#navi-search-toggle').prop('checked', false);
    }
  });
};

window.addEventListener(
  'message',
  (event) => {
    if (allowedDomainsForMessageEvent.indexOf(event.origin) === -1) {
      return;
    }

    if (event.data.type === 'datalayer_push' && window.dataLayer.length !== -1) {
      console.log(event.data);
      window.dataLayer.push(event.data.payload);
    }

    if (event.data.type === 'redirect') {
      console.log(event.data);
      window.location.href = event.data.payload.target_url;
    }
  },
  false
);

initSearch();
